var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorBuildingPeople240)",
    d: "M4 4.25A2.25 2.25 0 0 1 6.25 2h7.5A2.25 2.25 0 0 1 16 4.25V9.5h1.75A2.25 2.25 0 0 1 20 11.75V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorBuildingPeople247)",
    d: "M4 4.25A2.25 2.25 0 0 1 6.25 2h7.5A2.25 2.25 0 0 1 16 4.25V9.5h1.75A2.25 2.25 0 0 1 20 11.75V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorBuildingPeople248)",
    d: "M4 4.25A2.25 2.25 0 0 1 6.25 2h7.5A2.25 2.25 0 0 1 16 4.25V9.5h1.75A2.25 2.25 0 0 1 20 11.75V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorBuildingPeople249)",
    d: "M4 4.25A2.25 2.25 0 0 1 6.25 2h7.5A2.25 2.25 0 0 1 16 4.25V9.5h1.75A2.25 2.25 0 0 1 20 11.75V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorBuildingPeople24a)",
    d: "M4 4.25A2.25 2.25 0 0 1 6.25 2h7.5A2.25 2.25 0 0 1 16 4.25V9.5h1.75A2.25 2.25 0 0 1 20 11.75V21h-2v1H4.75a.75.75 0 0 1-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorBuildingPeople241)",
    d: "M7 6.5a1 1 0 1 0 2 0a1 1 0 0 0-2 0m1 6a1 1 0 1 0 0 2a1 1 0 0 0 0-2M8 9a1 1 0 1 0 0 2a1 1 0 0 0 0-2m4-3.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2M12 9a1 1 0 1 0 0 2a1 1 0 0 0 0-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorBuildingPeople242)",
    d: "M20 22c2.2 0 3-1.216 3-2.4a1.6 1.6 0 0 0-1.6-1.6h-2.8a1.6 1.6 0 0 0-1.6 1.6c0 1.183.8 2.4 3 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorBuildingPeople24b)",
    fillOpacity: 0.5,
    d: "M20 22c2.2 0 3-1.216 3-2.4a1.6 1.6 0 0 0-1.6-1.6h-2.8a1.6 1.6 0 0 0-1.6 1.6c0 1.183.8 2.4 3 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorBuildingPeople243)",
    d: "M20 17a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorBuildingPeople244)",
    d: "M15.5 23c2.567 0 3.5-1.52 3.5-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2c0 1.48.933 3 3.5 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorBuildingPeople245)",
    d: "M15.5 23c2.567 0 3.5-1.52 3.5-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2c0 1.48.933 3 3.5 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorBuildingPeople246)",
    d: "M15.5 17a2 2 0 1 0 0-4a2 2 0 0 0 0 4"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorBuildingPeople240",
    x1: 4,
    x2: 23.081,
    y1: 2.625,
    y2: 22.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2764e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorBuildingPeople241",
    x1: 9.15,
    x2: 13.953,
    y1: 4.5,
    y2: 15.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3e0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorBuildingPeople242",
    x1: 18.427,
    x2: 20.038,
    y1: 18.532,
    y2: 22.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#9c6cfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a41dc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorBuildingPeople243",
    x1: 19.213,
    x2: 20.742,
    y1: 14.399,
    y2: 16.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#9c6cfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a41dc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorBuildingPeople244",
    x1: 13.665,
    x2: 15.776,
    y1: 18.665,
    y2: 23.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#bd96ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c6cfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorBuildingPeople245",
    x1: 15.5,
    x2: 18.521,
    y1: 17.405,
    y2: 25.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#885edb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e362f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorBuildingPeople246",
    x1: 14.451,
    x2: 16.49,
    y1: 13.532,
    y2: 16.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#bd96ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c6cfe"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorBuildingPeople247",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.6875 .0625 -.05412 4.92472 14.313 20.656)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4a43cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#4a43cb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorBuildingPeople248",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.875 -.125 .10824 5.08708 19.438 19.719)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4a43cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#4a43cb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorBuildingPeople249",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.0625 3.53125 -3.76667 .06667 15.75 15.875)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4a43cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a43cb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorBuildingPeople24a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(91.45 2.588 17.915)scale(2.46954 2.63418)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4a43cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a43cb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorBuildingPeople24b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.94861 -.58333 .6871 4.65104 16.239 20)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#3b148a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b148a",
    stopOpacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.3919fd774b32f1a3a6d2033d5384e4c4.svg";
export { ForwardRef as ReactComponent };